"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserStorageCache = /** @class */ (function () {
    /**
     *
     * @param applicationName The name of your application
     * @param namespace Used to group together treatments into a given namespace.
     */
    function BrowserStorageCache(applicationName, ttl, namespace) {
        this.applicationName = applicationName;
        this.ttl = ttl;
        this.namespace = namespace;
        this.cacheKey = "Weblabs." + this.applicationName + (this.namespace ? '.' + this.namespace : '');
    }
    BrowserStorageCache.prototype.getCachedWeblabs = function () {
        var _this = this;
        var weblabs = [];
        var data = this.getCachedData();
        var foundExpired = false;
        Object.keys(data.treatmentMap).forEach(function (weblabId) {
            var cacheRecord = data.treatmentMap[weblabId];
            if (!_this.isExpired(cacheRecord)) {
                weblabs.push(cacheRecord.weblab);
            }
            else {
                foundExpired = true;
                delete data.treatmentMap[weblabId];
            }
        });
        if (foundExpired) {
            this.writeCachedData(data);
        }
        return weblabs;
    };
    BrowserStorageCache.prototype.getTreatment = function (weblabId) {
        var data = this.getCachedData();
        var cacheRecord = data.treatmentMap[weblabId];
        if (!cacheRecord || this.isExpired(cacheRecord)) {
            return undefined;
        }
        return cacheRecord.treatment;
    };
    BrowserStorageCache.prototype.addTreatment = function (treatment, weblab) {
        var key = treatment.weblabId;
        var data = this.getCachedData();
        var expirationTime = this.getExpirationTime();
        data.treatmentMap[key] = {
            treatment: treatment,
            weblab: weblab,
            expirationTime: expirationTime,
        };
        this.writeCachedData(data);
    };
    BrowserStorageCache.prototype.hasTreatment = function (weblabId) {
        var data = this.getCachedData();
        var cacheRecord = data.treatmentMap[weblabId];
        return (data.treatmentMap[weblabId] != null && !this.isExpired(cacheRecord));
    };
    BrowserStorageCache.prototype.clearTreatment = function (weblabId) {
        var data = this.getCachedData();
        if (data.treatmentMap[weblabId]) {
            delete data.treatmentMap[weblabId];
            this.writeCachedData(data);
        }
    };
    BrowserStorageCache.prototype.clearAllTreatments = function () {
        sessionStorage.removeItem(this.cacheKey);
    };
    BrowserStorageCache.prototype.getExpirationTime = function () {
        var ttlMillis = this.ttl * 1000;
        return new Date().getTime() + ttlMillis;
    };
    BrowserStorageCache.prototype.isExpired = function (cacheRecord) {
        var currentTime = new Date().getTime();
        return cacheRecord.expirationTime <= currentTime;
    };
    BrowserStorageCache.prototype.getCachedData = function () {
        var cachedValueString = sessionStorage.getItem(this.cacheKey);
        if (cachedValueString) {
            return JSON.parse(cachedValueString);
        }
        return {
            treatmentMap: {},
        };
    };
    BrowserStorageCache.prototype.writeCachedData = function (value) {
        var cacheValueString = JSON.stringify(value);
        sessionStorage.setItem(this.cacheKey, cacheValueString);
    };
    return BrowserStorageCache;
}());
exports.BrowserStorageCache = BrowserStorageCache;
